import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Web3 from 'web3';

// Dashboard page of a Lockbox
// Will pass in lots of props
function DashboardTab(props) {
    const [nativeTVL, setNativeTVL] = useState(0)

    const handleTVL = (event) => {
        event.preventDefault();
        submitTVL();
    }
    
    const submitTVL = async () => {
        let tvlNative = await props.lockbox.methods.contractNativeBalance().call({ from: props.address });
        tvlNative = Web3.utils.fromWei(tvlNative, "ether");
        setNativeTVL(tvlNative)
    }

    return (
        <div>
            <h5>Lockbox TVL: {nativeTVL} ETH</h5>
            <Button variant="dark" onClick={handleTVL}>Retrieve TVL</Button>
        </div>
    )
}

export default DashboardTab
